module.exports = __webpack_public_path__ + "static/img/bb4.3389ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb4.png
// module id = 4YgO
// module chunks = 2